import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { apiRequest } from "@/lib/api-request";

// The public schema has its own client and no retained entity cache
// (@adr SPARK-0058-public-applications-use-two-narrow-bff-endpoints@1). The BFF accepts each public write only at an
// endpoint of its own, with limits for exactly that operation; reads go to /public-flux. The operation name picks the
// endpoint, and the BFF checks the document again, so a renamed operation is refused, never widened.
const ENDPOINTS: Record<string, string> = {
  SubmitPublicListingApplication: "public-flux/applications",
  ConfirmPublicListingApplication: "public-flux/confirmations",
};

export function publicEndpointFor(body: unknown): string {
  try {
    const operation = typeof body === "string" ? (JSON.parse(body) as { operationName?: unknown }).operationName : undefined;
    return (typeof operation === "string" && ENDPOINTS[operation]) || "public-flux";
  } catch {
    return "public-flux";
  }
}

export const publicClient = new ApolloClient({
  devtools: { enabled: import.meta.env.MODE !== "test" },
  cache: new InMemoryCache(),
  link: new HttpLink({
    // The public BFF accepts only query, variables and operationName.
    enhancedClientAwareness: { transport: false },
    uri: "public-flux",
    fetch: async (_input, init) => (await apiRequest(publicEndpointFor(init?.body), {
      method: "POST", body: init?.body, signal: init?.signal,
      headers: { "Content-Type": "application/json" }, csrf: true,
    })).response,
  }),
  defaultOptions: {
    watchQuery: { fetchPolicy: "no-cache" },
    query: { fetchPolicy: "no-cache" },
    mutate: { fetchPolicy: "no-cache" },
  },
});
